import type { ConnectionItem } from '@/lib/api/connections';

type ConnectionLabelInput = Pick<
  ConnectionItem,
  'display_name' | 'connector_name' | 'connector_key'
> &
  Partial<Pick<ConnectionItem, 'auth_profile_name' | 'auth_profile_slug'>>;

export function connectionLabel(c: ConnectionLabelInput): string {
  if (c.display_name?.trim()) return c.display_name.trim();
  const connector = c.connector_name ?? c.connector_key;
  const suffix = c.auth_profile_name ?? c.auth_profile_slug;
  return suffix ? `${connector} · ${suffix}` : connector;
}
